'use client';

import React from 'react';
import TicketVerification from '../../components/TicketVerification';
import Footer from '../../components/Footer';
import Head from 'next/head';

const TicketVerificationPage = () => {
  return (
    <div className="min-h-screen bg-[var(--background)] py-12">
      <Head>
        <title>Ticket Verification | Bus Ticketing System</title>
        <meta name="description" content="Verify your bus ticket details and booking information" />
      </Head>
      <TicketVerification />
      <Footer />
    </div>
  );
};

export default TicketVerificationPage;